import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Box, CircularProgress, Paper, Typography, Alert } from '@mui/material';
import apiService from '../services/api';
import { useAuth } from '../contexts/AuthContext';

const SsoLogin: React.FC = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { setAuthState } = useAuth();
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const raw = searchParams.get('token');
    if (!raw) {
      setError('Missing token');
      return;
    }

    let cancelled = false;
    (async () => {
      try {
        const res = await apiService.ssoLogin(raw.trim());
        if (cancelled) return;
        localStorage.setItem('token', res.token);
        localStorage.setItem('user', JSON.stringify(res.user));
        setAuthState(res.token, res.user);
        navigate('/dashboard', { replace: true });
      } catch (e: unknown) {
        if (cancelled) return;
        const msg =
          (e as { response?: { data?: { message?: string } } })?.response?.data?.message ||
          'SSO login failed';
        setError(String(msg));
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [searchParams, navigate, setAuthState]);

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        p: 2,
      }}
    >
      <Paper sx={{ p: 4, maxWidth: 420, width: '100%', textAlign: 'center' }}>
        {error ? (
          <Alert severity="error">{error}</Alert>
        ) : (
          <>
            <CircularProgress sx={{ mb: 2 }} />
            <Typography variant="body1">Signing you in…</Typography>
          </>
        )}
      </Paper>
    </Box>
  );
};

export default SsoLogin;
